import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

const ContentReportChart = ({ contentReport }) => {
  // Extract labels and data from the contentReport array
  const labels = contentReport.map((item) => item.content_type);
  const dataValues = contentReport.map((item) =>
    parseFloat(item.avg_completion_percentage)
  );

  const data = {
    labels,
    datasets: [
      {
        label: "Average Completion (%)",
        data: dataValues,
        backgroundColor: "rgba(54, 162, 235, 0.6)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
    //   title: {
    //     display: true,
    //     text: "Content Completion Report",
    //   },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: "Completion Percentage",
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default ContentReportChart;
